<template>
    <app-content-admin>
        <template slot="header">View Ad Details</template>
        <template slot="button">
            <v-btn style="margin-left: auto" large color="secondary" to="/ad">
                Back
            </v-btn>
        </template>

        <v-layout row wrap>
            <v-flex xs12 lg6 mx-auto>
                <v-card>
                    <v-card-text>
                        <v-container fluid grid-list-xs>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Ad Name')"
                                        v-model="form.ads_name"
                                        :rules="[rules.required('Ad Name')]"
                                        :data-label="$t('Ad Name')"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Link Url')"
                                        v-model="form.ads_url"
                                        :rules="[rules.required('Link Url')]"
                                        :data-label="$t('Link Url')"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-switch
                                        :label="$t('Active')"
                                        v-model="form.ads_active"
                                        :data-label="$t('Active')"
                                        outlined
                                    ></v-switch>
                                </v-flex>

                                <v-flex xs12>
                                    <input
                                        :label="$t('Start Date')"
                                        :rules="[rules.required('Start Date')]"
                                        type="datetime-local"
                                        v-model="form.ads_start_date"
                                        @input="formatStartDate"
                                    />
                                </v-flex>

                                <v-flex xs12>
                                    <input
                                        type="datetime-local"
                                        v-model="form.ads_end_date"
                                        @input="formatEndDate"
                                    />
                                </v-flex>

                                <v-select
                                    v-model="form.selectedPlacementNames"
                                    :items="GetPlacementData"
                                    item-text="placement_name"
                                    item-value="placement_name"
                                    label="Select"
                                    multiple
                                    return-object
                                    clearable
                                    placeholder="Select Placement Names"
                                    persistent-hin
                                    @input="updateSelectedPlacementNames"
                                    :rules="[
                                        (v) =>
                                            (!!v && v.length > 0) ||
                                            'Please select at least one Placement Name',
                                    ]"
                                />

                             

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Image Url')"
                                        v-model="form.ads_external_img"
                                        :rules="[rules.required('Image Url')]"
                                        :data-label="$t('Image Url')"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-row>
                                        <v-col cols="10">
                                            <div class="dropzone-wrapper">
                                                <vue-dropzone
                                                    ref="myDropzone"
                                                    id="dropzone"
                                                    :options="dropzoneOptions"
                                                    @vdropzone-success="
                                                        onUploadSuccess
                                                    "
                                                ></vue-dropzone>
                                            </div>
                                        </v-col>
                                        <v-col cols="2">
                                            <div class="upload-button-wrapper">
                                                <v-btn
                                                    @click="handleUploadClick"
                                                    >Upload</v-btn
                                                >
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-flex>

                                <v-flex xs12 v-if="isImageUrlValid" >
                                    <v-img
                                        :width="'60%'"
                                     
                                        :src="form.ads_external_img"
                                    ></v-img>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Ad Description')"
                                        v-model="form.ads_description"
                                        :rules="[
                                            rules.required('Ad Description'),
                                        ]"
                                        :data-label="$t('Ad Description')"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Ad Maxtimes')"
                                        v-model="form.ads_maxtimes"
                                        :data-label="$t('Ad Maxtimes')"
                                        outlined
                                        type="number"
                                        min="0"
                                        @input="
                                            handlingZeroNegativeValue(
                                                'ads_maxtimes'
                                            )
                                        "
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Ad Daily_maxtimes')"
                                        v-model="form.ads_daily_maxtimes"
                                        :data-label="$t('Ad Daily_maxtimes')"
                                        outlined
                                        type="number"
                                        min="0"
                                        @input="
                                            handlingZeroNegativeValue(
                                                'ads_daily_maxtimes'
                                            )
                                        "
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Ad User_daily_maxtimes')"
                                        v-model="form.ads_user_daily_maxtimes"
                                        :data-label="
                                            $t('Ad User_daily_maxtimes')
                                        "
                                        outlined
                                        type="number"
                                        min="0"
                                        @input="
                                            handlingZeroNegativeValue(
                                                'ads_user_daily_maxtimes'
                                            )
                                        "
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Ad Maxclicks')"
                                        v-model="form.ads_maxclicks"
                                        :data-label="$t('Ad Maxclicks')"
                                        outlined
                                        type="number"
                                        min="0"
                                        @input="
                                            handlingZeroNegativeValue(
                                                'ads_maxclicks'
                                            )
                                        "
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="updateAd"
                            class="form-submit"
                        >
                            Submit
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";
import router from "../../router";


import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueDropzone from "vue2-dropzone";

export default {
    mixins: [vForm],

    data() {
        return {
            project_list: [],
            form: {
                ads_id: null,
                ads_name: null,
                ads_url: null,
                ads_active: 0,
                ads_external_img: null,
                ads_start_date: null,
                ads_end_date: null,
                token: null,
                selectedPlacementNames: [],

                //Placement Ids Props
                relatedPlacementIds: [],
                placement_names: [],
                selectedPlacementIds: [], // Initialize selectedPlacementIds as an empty array

                //Image detail info
                ads_description: null,
                ads_maxtimes: null,
                ads_daily_maxtimes: null,
                ads_user_daily_maxtimes: null,
                ads_maxclicks: null,
            },
            GetPlacementData: [],
            dropzoneOptions: {
                url: "https://api.imgur.com/3/upload", // specify your upload endpoint
                maxFilesize: 3, // set maximum file size in MB
                acceptedFiles: "image/jpeg,image/png", // specify accepted file types
                addRemoveLinks: true, // show remove links on uploaded files
                maxFiles: 1,
                autoProcessQueue: false, // prevent automatic upload
            },

        };
    },

    components: { ActiveLabel, VueDropzone },

    created() {
        this.form.ads_id = this.$route.params.id;
        this.getAd();
        this.getAllPlacementIds();
    },

    methods: {
        //Update specific ad data
        async updateAd() {
            let loader = this.$loading.show();
            try {
                this.form.placement_names = this.form.selectedPlacementNames;

                let res = await axios.post(`/api/auth/update_ad`, this.form);
                console.log("Current Update Ad data:", this.form);
                if (res.status == 200) {
                    this.$toastr.s("Ad update successfully");

                    router.push("/ad");
                }
            } catch (err) {
                if (err.response.status == 400) {
                    // Validation errors returned by the server
                    console.log("Update Ad Error", err.response);
                    //this.$toastr.e("Please input all required data");
                } else {
                    // this.$toastr.e("An error occurred while creating the Ad.");
                    console.log("Error create ad", err);
                }
            } finally {
                loader.hide();
            }
        },

        //Read specific ad data
        async getAd() {
            let loader = this.$loading.show();
            try {
                let res = await axios.get(`/api/auth/get_ad`, {
                    params: { ads_id: this.form.ads_id },
                });

                if (res.status == 200) {
                    const ad = res.data.ads;
                    this.form.ads_name = ad.ads_name;
                    this.form.ads_url = ad.ads_url;
                    this.form.ads_active = ad.ads_active;
                    this.form.ads_external_img = ad.ads_image_url;
                    this.form.ads_start_date = ad.ads_start_date;
                    this.form.ads_end_date = ad.ads_end_date;
                    //Image description
                    this.form.ads_description = ad.ads_description;
                    this.form.ads_maxtimes = ad.ads_maxtimes;
                    this.form.ads_daily_maxtimes = ad.ads_daily_maxtimes;
                    this.form.ads_user_daily_maxtimes =
                        ad.ads_user_daily_maxtimes;
                    this.form.ads_maxclicks = ad.ads_maxclicks;
                    this.form.selectedPlacementNames = res.data.placements.map(
                        (placement) => placement.placement_name
                    );

                    // console.log("Ads Data:", this.form);
                    // console.log(
                    //     "Placement Names:",
                    //     this.form.selectedPlacementNames
                    // );
                }
            } catch (err) {
                this.$toastr.e(err.response.data.message);
                console.log("Get specific ad data fail");
            } finally {
                loader.hide();
            }
        },

        //Read All placements data
        getAllPlacementIds() {
            let loader = this.$loading.show();

            axios
                .get(`/api/auth/get_placement_list`)
                .then((res) => res.data)
                .then((res) => {
                    this.GetPlacementData = res.result.map(
                        (item) => item.placement.placement_name
                    );

                    // console.log(
                    //     "Current All placement name:",
                    //     this.GetPlacementData
                    // );
                })

                .catch((e) => {
                    this.$toastr.e(e.message);
                })
                .finally(() => {
                    loader.hide();
                });
        },

        //Update placement id ui value
        updateSelectedPlacementNames(selectedPlacementNames) {
            this.form.selectedPlacementNames = selectedPlacementNames.map(
                (placement) => placement.placement_name
            );

            // Check if selectedZoneNames is an array of objects or an array of strings
            if (
                Array.isArray(selectedPlacementNames) &&
                selectedPlacementNames.length > 0 &&
                typeof selectedPlacementNames[0] === "object"
            ) {
                // Map selectedZoneNames to zone_name if it's an array of objects
                this.form.selectedPlacementNames = selectedPlacementNames.map(
                    (placement) => placement.placement_name
                );
            } else {
                // Keep selectedZoneNames as it is if it's an array of strings
                this.form.selectedPlacementNames = selectedPlacementNames;
            }

            console.log(
                "Latest current placement name:",
                this.form.selectedPlacementNames
            );
        },

        //Modify date ui data format so match backend date format allow create api integrate success
        formatStartDate() {
            if (this.form.ads_start_date) {
                const date = new Date(this.form.ads_start_date);
                this.form.ads_start_date = date
                    .toISOString()
                    .slice(0, 19)
                    .replace("T", " ");
            }
        },

        formatEndDate() {
            if (this.form.ads_end_date) {
                const date = new Date(this.form.ads_end_date);
                this.form.ads_end_date = date
                    .toISOString()
                    .slice(0, 19)
                    .replace("T", " ");
            }
        },

        //Zero & Neg Value Handling
        handlingZeroNegativeValue(field) {
            // Ensure that the value is not negative
            if (this.form[field] < 0) {
                this.form[field] = 0;
            }

            // Remove leading zeros
            if (this.form[field].length > 1 && this.form[field][0] === "0") {
                this.form[field] = this.form[field].slice(1);
            }
        },
        onUploadSuccess(file, response) {
            console.log("File uploaded:", file);
            console.log("Server response:", response);
        },
        handleUploadClick() {
            console.log("Upload Success")
        },
    },

    computed: {
        //Validation image url
        isImageUrlValid() {
            // Use a regular expression to validate the URL format
            const urlPattern =
                /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w.-]*)*\/?$/;
            return urlPattern.test(this.form.ads_external_img);
        },
    },
};
</script>

<style>
.theme--light.v-text-field--outlined:not(
        .v-input--is-focused
    ).v-input--is-disabled
    > .v-input__control
    > .v-input__slot
    fieldset {
    color: rgba(0, 0, 0, 0.36);
}

.theme--light.v-label--is-disabled {
    color: rgba(0, 0, 0, 0.6);
}

.theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
    color: rgba(0, 0, 0, 0.6);
}

.theme--light.v-select .v-select__selection--disabled {
    color: rgba(0, 0, 0, 0.6);
}
</style>
